import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ParametroObtenerPorIdService } from '../../../Services/ParametroObtenerPorIdService';
import { EnumParametro } from '../../../Utils/Enumeradores/ComunEnum';

const ModalFormulaIsp = ({ show, onHide }) => {
	const [formulaIspUrl, setFormulaIspUrl] = useState('');

	useEffect(() => {
		let isMounted = true;

		const fetchFormulaUrl = async () => {
			if (!show) {
				return;
			}

			const response = await ParametroObtenerPorIdService(EnumParametro.UrlInfoIspCdo);

			if (!isMounted) {
				return;
			}

			if (response?.status === 200) {
				setFormulaIspUrl(response.data ?? '');
			}
		};

		fetchFormulaUrl();

		return () => {
			isMounted = false;
		};
	}, [show]);

	const myHTML = '<iframe src="' + formulaIspUrl + '"></iframe>';

	return (
		<Modal
			show={show}
			onHide={onHide}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				{/* <Modal.Title className='fs-4'>Formula</Modal.Title> */}
			</Modal.Header>
			<Modal.Body>
				<div className='ratio ratio-1x1' dangerouslySetInnerHTML={{ __html: myHTML }} />
			</Modal.Body>
		</Modal>
	);
};

export default ModalFormulaIsp;
